<template>
	<v-card
		v-if="drawer"
		flat
		class="conversation-info-panel fill-height d-flex flex-column"
		style="border-left: 1px solid rgba(0, 0, 0, 0.12); border-top-right-radius: 15px !important; height: 100%;"
	>
		<v-card-title style="padding: 24px">
			<v-icon left>mdi-information-outline</v-icon>
			Informazioni Conversazione
			<v-spacer></v-spacer>
			<v-btn icon @click="drawer = false">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>

		<v-divider></v-divider>

		<v-card flat v-if="conversation" style="flex: 1; overflow-y: auto; max-height: 100%;">
			<v-card-text>
				<!-- Informazioni Base -->
				<h4 class="subtitle-1 mb-2 font-weight-bold">Informazioni Base</h4>
				<v-list dense>
					<v-list-item>
						<v-list-item-icon>
							<v-icon>mdi-phone</v-icon>
						</v-list-item-icon>
						<v-list-item-content class="pl-4">
							<v-list-item-title>Numero WhatsApp</v-list-item-title>
							<v-list-item-subtitle>
								{{ conversation.telephone_number }}
								<v-chip
									v-if="(contactData && contactData.whatsapp_verified) || (companyData && companyData.whatsapp_verified)"
									color="success"
									x-small
									class="ml-2"
								>
									<v-icon x-small left>mdi-check-decagram</v-icon>
									Verificato
								</v-chip>
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-icon>
							<v-icon>mdi-information-outline</v-icon>
						</v-list-item-icon>
						<v-list-item-content class="pl-4">
							<v-list-item-title>Stato</v-list-item-title>
							<v-list-item-subtitle>
								<v-chip
									:color="getStatusColor(conversation.status)"
									x-small
									dark
								>
									{{ getStatusLabel(conversation.status) }}
								</v-chip>
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="conversation.unread_count > 0">
						<v-list-item-icon>
							<v-icon>mdi-message-badge</v-icon>
						</v-list-item-icon>
						<v-list-item-content class="pl-4">
							<v-list-item-title>Messaggi non letti</v-list-item-title>
							<v-list-item-subtitle>
								<v-chip
									color="red"
									x-small
									dark
								>
									{{ conversation.unread_count }}
								</v-chip>
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-icon>
							<v-icon>mdi-calendar</v-icon>
						</v-list-item-icon>
						<v-list-item-content class="pl-4">
							<v-list-item-title>Ultimo messaggio</v-list-item-title>
							<v-list-item-subtitle>{{ formatDate(conversation.last_message_at) }}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-icon>
							<v-icon>mdi-timer</v-icon>
						</v-list-item-icon>
						<v-list-item-content class="pl-4">
							<v-list-item-title>Sessione Template</v-list-item-title>
							<v-list-item-subtitle>
								<v-chip
									:color="conversation.is_template_session ? 'warning' : 'success'"
									x-small
									dark
								>
									{{ conversation.is_template_session ? 'Solo Template' : 'Sessione Attiva' }}
								</v-chip>
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="conversation.session_expires_at">
						<v-list-item-icon>
							<v-icon>mdi-clock-alert</v-icon>
						</v-list-item-icon>
						<v-list-item-content class="pl-4">
							<v-list-item-title>Scadenza Sessione</v-list-item-title>
							<v-list-item-subtitle>{{ formatDate(conversation.session_expires_at) }}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>

				<!-- Gestione Conversazione -->
				<v-divider class="my-4"></v-divider>

				<h4 class="subtitle-1 mb-2 font-weight-bold">Gestione Conversazione</h4>

				<v-list dense>
					<v-list-item>
						<v-list-item-content>
							<v-autocomplete
								v-model="editedOwnerId"
								:items="$store.getters.usersSeq"
								item-text="value"
								item-value="id"
								label="Responsabile Conversazione"
								outlined
								dense
								clearable
								prepend-icon="mdi-account-tie"
								hint="Seleziona l'utente responsabile di questa conversazione"
								persistent-hint
								:disabled="saving"
							>
								<template v-slot:append-outer>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												color="primary"
												:disabled="!hasOwnerChanged || saving"
												:loading="saving"
												@click="saveOwner"
												v-bind="attrs"
												v-on="on"
											>
												<v-icon>mdi-content-save</v-icon>
											</v-btn>
										</template>
										<span>Salva modifiche</span>
									</v-tooltip>
								</template>
							</v-autocomplete>
						</v-list-item-content>
					</v-list-item>
				</v-list>

				<!-- Contatto -->
				<template v-if="contactData">
					<v-divider class="my-4"></v-divider>
					<h4 class="subtitle-1 mb-2 font-weight-bold">Contatto</h4>
					<v-list dense>
						<v-list-item link @click="viewContact">
							<v-list-item-icon>
								<v-icon>mdi-account</v-icon>
							</v-list-item-icon>
							<v-list-item-content class="pl-4">
								<v-list-item-title class="primary--text font-weight-medium">
									{{ contactData.name }} {{ contactData.surname }}
								</v-list-item-title>
								<v-list-item-subtitle v-if="contactData.primary_email">
									<v-icon x-small class="mr-1">mdi-email</v-icon>{{ contactData.primary_email }}
								</v-list-item-subtitle>
								<v-list-item-subtitle v-if="contactData.primary_telephone">
									<v-icon x-small class="mr-1">mdi-phone</v-icon>{{ contactData.primary_telephone }}
									<v-chip
										v-if="contactData.whatsapp_verified"
										color="success"
										x-small
										class="ml-2"
									>
										<v-icon x-small left>mdi-check-decagram</v-icon>
										Verificato
									</v-chip>
								</v-list-item-subtitle>
							</v-list-item-content>
							<v-list-item-action>
								<v-icon small color="primary">mdi-open-in-new</v-icon>
							</v-list-item-action>
						</v-list-item>

						<v-list-item>
							<v-list-item-icon>
								<v-icon>mdi-checkbox-marked</v-icon>
							</v-list-item-icon>
							<v-list-item-content class="pl-4">
								<v-list-item-title>Consenso WhatsApp</v-list-item-title>
								<v-list-item-subtitle>
									<v-chip
										:color="contactData.whatsapp_opted_in ? 'success' : 'error'"
										x-small
										dark
									>
										{{ contactData.whatsapp_opted_in ? 'Confermato' : 'Non confermato' }}
									</v-chip>
									<span v-if="contactData.whatsapp_opted_in_date" class="ml-2">
										({{ formatDate(contactData.whatsapp_opted_in_date) }})
									</span>
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</template>

				<!-- Azienda -->
				<template v-if="companyData">
					<v-divider class="my-4"></v-divider>
					<h4 class="subtitle-1 mb-2 font-weight-bold">{{ businessType.label }}</h4>
					<v-list dense>
						<v-list-item link @click="viewCompany">
							<v-list-item-icon>
								<v-icon>mdi-domain</v-icon>
							</v-list-item-icon>
							<v-list-item-content class="pl-4">
								<v-list-item-title class="primary--text font-weight-medium">
									{{ companyData.business_name || companyData.name }}
								</v-list-item-title>
								<v-list-item-subtitle v-if="companyData.primary_email">
									<v-icon x-small class="mr-1">mdi-email</v-icon>{{ companyData.primary_email }}
								</v-list-item-subtitle>
							</v-list-item-content>
							<v-list-item-action>
								<v-icon small color="primary">mdi-open-in-new</v-icon>
							</v-list-item-action>
						</v-list-item>

						<v-list-item v-if="companyData.legal_address">
							<v-list-item-icon>
								<v-icon>mdi-map-marker</v-icon>
							</v-list-item-icon>
							<v-list-item-content class="pl-4">
								<v-list-item-title>Indirizzo</v-list-item-title>
								<v-list-item-subtitle>{{ companyData.legal_address }}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>

						<v-list-item v-if="companyData.vat_number">
							<v-list-item-icon>
								<v-icon>mdi-credit-card</v-icon>
							</v-list-item-icon>
							<v-list-item-content class="pl-4">
								<v-list-item-title>P.IVA</v-list-item-title>
								<v-list-item-subtitle>{{ companyData.vat_number }}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>

						<v-list-item v-if="companyData.preferred_channel">
							<v-list-item-icon>
								<v-icon>mdi-message-settings</v-icon>
							</v-list-item-icon>
							<v-list-item-content class="pl-4">
								<v-list-item-title>Canale Preferito</v-list-item-title>
								<v-list-item-subtitle>
									<v-chip x-small :color="getChannelColor(companyData.preferred_channel)">
										{{ companyData.preferred_channel }}
									</v-chip>
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>

						<v-list-item>
							<v-list-item-icon>
								<v-icon>mdi-checkbox-marked</v-icon>
							</v-list-item-icon>
							<v-list-item-content class="pl-4">
								<v-list-item-title>Consenso WhatsApp</v-list-item-title>
								<v-list-item-subtitle>
									<v-chip
										:color="companyData.whatsapp_opted_in ? 'success' : 'error'"
										x-small
										dark
									>
										{{ companyData.whatsapp_opted_in ? 'Confermato' : 'Non confermato' }}
									</v-chip>
									<span v-if="companyData.whatsapp_opted_in_date" class="ml-2">
										({{ formatDate(companyData.whatsapp_opted_in_date) }})
									</span>
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</template>

				<v-divider class="my-4"></v-divider>

				<h4 class="subtitle-1 mb-2 font-weight-bold">Azioni Rapide</h4>

				<v-btn
					v-if="company && isClient && $store.getters.checkModelPermissions('saleorder')"
					block
					outlined
					class="mb-2"
					@click="viewOrders"
				>
					<v-icon left>mdi-shopping</v-icon>
					Visualizza Ordini
				</v-btn>

				<v-btn
					v-if="company && isClient && $store.getters.checkModelPermissions('trouble')"
					block
					outlined
					class="mb-2"
					@click="viewTickets"
				>
					<v-icon left>mdi-ticket</v-icon>
					Visualizza Ticket
				</v-btn>

				<v-btn
					v-if="company && isClient && $store.getters.checkModelPermissions('saleinvoice')"
					block
					outlined
					class="mb-2"
					@click="viewInvoices"
				>
					<v-icon left>mdi-file-document</v-icon>
					Visualizza Fatture
				</v-btn>

				<v-btn
					block
					outlined
					color="error"
					@click="openCloseDialog"
					:loading="closing"
				>
					<v-icon left>mdi-close</v-icon>
					Chiudi Conversazione
				</v-btn>
			</v-card-text>
		</v-card>

		<!-- Dialog di conferma chiusura -->
		<v-dialog v-model="closeDialog" max-width="600" persistent>
			<v-card class="round-card">
				<v-card-title class="pa-3 background-1">
					<v-icon left color="warning">mdi-alert</v-icon>
					Chiudi Conversazione
				</v-card-title>

				<v-divider></v-divider>

				<v-card-text class="pa-6">
					<p class="text-body-1 mb-2">Sei sicuro di voler chiudere questa conversazione?</p>
					<p class="text-body-2 text--secondary">
						La conversazione verrà archiviata e il suo stato sarà impostato su "chiusa". Potrai riaprirla in seguito se necessario.
					</p>
				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions class="px-4 py-3 background-1">
					<v-spacer></v-spacer>
					<v-btn text @click="cancelClose">
						Annulla
					</v-btn>
					<v-btn
						text
						color="error"
						@click="closeConversation"
						:loading="closing"
					>
						<v-icon left small>mdi-check</v-icon>
						Conferma
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
// import { format, parseISO } from 'date-fns'
// import { it } from 'date-fns/locale'

// Rotte e etichette dell'anagrafica collegata, per valore della colonna `business`
const BUSINESS_TYPES = {
	0: { prefix: 'companies', label: 'Azienda' },
	1: { prefix: 'suppliers', label: 'Fornitore' },
	2: { prefix: 'leads', label: 'Lead' },
	3: { prefix: 'prospects', label: 'Prospect' }
}

export default {
	name: 'ConversationInfo',

	props: {
		conversation: {
			type: Object,
			default: null
		},
		value: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			company: null,
			contact: null,
			assignedUser: null,
			closing: false,
			closeDialog: false,
			owner: null,
			editedOwnerId: null,
			saving: false
		}
	},

	computed: {
		drawer: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			}
		},

		hasOwnerChanged() {
			return this.editedOwnerId !== this.conversation?.owner_id
		},

		contactData() {
			// L'API restituisce {models: {contact: {...}}}
			if (!this.contact) return null
			if (this.contact.models && this.contact.models.contact) {
				return this.contact.models.contact
			}
			return this.contact
		},

		companyData() {
			// Company già viene restituito correttamente
			return this.company
		},

		// La relazione company della conversazione può essere un cliente, un fornitore, un lead o un prospect
		businessType() {
			const business = this.conversation && this.conversation.company ? this.conversation.company.business : 0
			return BUSINESS_TYPES[business] || BUSINESS_TYPES[0]
		},

		isClient() {
			return this.businessType.prefix === 'companies'
		},

		// Solo i fornitori hanno referenti propri, lead e prospect usano quelli dei clienti
		isSupplier() {
			return this.businessType.prefix === 'suppliers'
		}
	},

	watch: {
		conversation: {
			immediate: true,
			handler(val) {
				// Reset dei dati precedenti
				this.company = null
				this.contact = null
				this.assignedUser = null
				this.owner = null
				this.editedOwnerId = null

				if (val) {
					// Inizializza editedOwnerId con il valore corrente
					this.editedOwnerId = val.owner_id

					if (val.company_id) {
						this.loadCompany()
					}
					if (val.contact_id) {
						this.loadContact()
					}
					if (val.assigned_user_id) {
						this.loadAssignedUser()
					}
					if (val.owner_id) {
						this.loadOwner()
					}
				}
			}
		}
	},

	methods: {
		async loadCompany() {
			if (!this.conversation || !this.conversation.company_id) return

			try {
				const response = await this.$http.get(`/${this.businessType.prefix}/${this.conversation.company_id}?lite=true`)
				this.company = response.data.model
			} catch (error) {
				console.error('Errore nel caricamento dell\'azienda:', error)
			}
		},

		async loadContact() {
			if (!this.conversation || !this.conversation.contact_id) return

			try {
				const endpoint = this.isSupplier ? 'suppliercontacts' : 'companycontacts'
				const response = await this.$http.get(`/${endpoint}/${this.conversation.contact_id}`)
				const data = response.data.model || response.data
				// L'API restituisce {models: {contact: {...}}}
				this.contact = data.models?.contact || data
			} catch (error) {
				console.error('Errore nel caricamento del contatto:', error)
			}
		},

		async loadAssignedUser() {
			if (!this.conversation || !this.conversation.assigned_user_id) return

			try {
				const response = await this.$http.get(`/users/${this.conversation.assigned_user_id}`)
				this.assignedUser = response.data.model || response.data
			} catch (error) {
				console.error('Errore nel caricamento dell\'utente assegnato:', error)
			}
		},

		async loadOwner() {
			if (!this.conversation || !this.conversation.owner_id) return

			try {
				const response = await this.$http.get(`/users/${this.conversation.owner_id}`)
				this.owner = response.data.model || response.data
			} catch (error) {
				console.error('Errore nel caricamento del responsabile:', error)
			}
		},

		async saveOwner() {
			if (!this.hasOwnerChanged) return

			this.saving = true

			try {
				const response = await this.axios.put(`whatsappconversations/${this.conversation.id}`, {
					owner_id: this.editedOwnerId
				})

				const updatedConversation = response.data.data || response.data

				this.$store.commit('setSnackbar', {
					value: true,
					color: 'success',
					text: 'Responsabile aggiornato con successo'
				})

				// Aggiorna i dati locali
				this.owner = updatedConversation.owner || null

				// Emetti evento al parent per aggiornare la conversazione
				this.$emit('conversation-updated', updatedConversation)
			} catch (error) {
				console.error('Errore nell\'aggiornamento del responsabile:', error)
				this.$store.commit('setSnackbar', {
					value: true,
					color: 'error',
					text: error.response?.data?.message || 'Errore nell\'aggiornamento del responsabile'
				})

				// Reset del valore in caso di errore
				this.editedOwnerId = this.conversation.owner_id
			} finally {
				this.saving = false
			}
		},

		formatDate(date) {
			if (!date) return 'Mai'
			try {
				// return format(parseISO(date), 'dd/MM/yyyy HH:mm', { locale: it })
				return new Date(date).toLocaleString('it-IT')
			} catch {
				return date
			}
		},

		getChannelColor(channel) {
			const colors = {
				'email': 'primary',
				'whatsapp': 'success',
				'sms': 'warning'
			}
			return colors[channel] || 'grey'
		},

		getStatusColor(status) {
			const colors = {
				'open': 'success',
				'assigned': 'primary',
				'closed': 'grey',
				'pending': 'warning'
			}
			return colors[status] || 'grey'
		},

		getStatusLabel(status) {
			const labels = {
				'open': 'Aperta',
				'assigned': 'Assegnata',
				'closed': 'Chiusa',
				'pending': 'In attesa'
			}
			return labels[status] || status
		},

		viewCompany() {
			if (this.company) {
				window.open(`#/${this.businessType.prefix}/${this.company.id}`, '_blank')
			}
		},

		viewContact() {
			if (this.contactData) {
				const contactId = this.contactData.id
				window.open(`#/${this.isSupplier ? 'suppliers' : 'companies'}/contacts/${contactId}`, '_blank')
			}
		},

		viewOrders() {
			if (this.company) {
				window.open(`#/companies/${this.company.id}/saleorders`, '_blank')
			}
		},

		viewTickets() {
			if (this.company) {
				window.open(`#/companies/${this.company.id}/tickets`, '_blank')
			}
		},

		viewInvoices() {
			if (this.company) {
				window.open(`#/companies/${this.company.id}/invoices`, '_blank')
			}
		},

		openCloseDialog() {
			this.closeDialog = true
		},

		async closeConversation() {
			this.closing = true
			this.closeDialog = false

			try {
				const response = await this.axios.put(`whatsappconversations/${this.conversation.id}`, {
					status: 'closed'
				})

				this.$store.commit('setSnackbar', {
					value: true,
					color: 'success',
					text: 'Conversazione chiusa con successo'
				})

				// Emetti evento al parent per aggiornare la conversazione
				this.$emit('conversation-updated', response.data.data || response.data)

				this.drawer = false
			} catch (error) {
				console.error('Errore nella chiusura della conversazione:', error)
				this.$store.commit('setSnackbar', {
					value: true,
					color: 'error',
					text: 'Errore nella chiusura della conversazione'
				})
			} finally {
				this.closing = false
			}
		},

		cancelClose() {
			this.closeDialog = false
		}
	}
}
</script>

<style scoped>
	.conversation-info-panel {
		width: 100%;
		max-width: 100%;
		min-width: 400px;
	}
</style>